var map = {
  "./": "83755",
  "./accordion": "28797",
  "./accordion.js": "28797",
  "./add": "73080",
  "./add.js": "73080",
  "./automation/tab": "98732",
  "./automation/tab.js": "98732",
  "./automation/wise_boxes": "78725",
  "./automation/wise_boxes.js": "78725",
  "./dashboard": "86403",
  "./dashboard.js": "86403",
  "./details/attributes": "19497",
  "./details/attributes.js": "19497",
  "./details/config_status": "58427",
  "./details/config_status.js": "58427",
  "./details/details": "47432",
  "./details/details.js": "47432",
  "./details/edit_panorama": "48672",
  "./details/edit_panorama.js": "48672",
  "./details/location": "82587",
  "./details/location.js": "82587",
  "./details/summary_info": "48353",
  "./details/summary_info.js": "48353",
  "./details/tab": "88885",
  "./details/tab.js": "88885",
  "./details/tariffs": "32265",
  "./details/tariffs.js": "32265",
  "./edit": "47947",
  "./edit.js": "47947",
  "./edit_tariffs": "71671",
  "./edit_tariffs.js": "71671",
  "./index": "83755",
  "./index.js": "83755",
  "./location_edit": "52811",
  "./location_edit.js": "52811",
  "./manage_attributes": "52378",
  "./manage_attributes.js": "52378",
  "./new_site": "75215",
  "./new_site.js": "75215",
  "./objectives": "76495",
  "./objectives.js": "76495",
  "./permissions": "16003",
  "./permissions.js": "16003",
  "./show": "96954",
  "./show.js": "96954",
  "./sort_widgets": "46249",
  "./sort_widgets.js": "46249",
  "./widgets/benchmark": "278",
  "./widgets/benchmark.js": "278",
  "./widgets/costs": "91571",
  "./widgets/costs.js": "91571",
  "./widgets/distribution": "94859",
  "./widgets/distribution.js": "94859"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 62589;
